import { useTranslations } from "@ui/providers/useTranslations";

import { AlertBanner } from "@jti/core-components/components/AlertBanner";

export interface PhoneVerificationProps {
  isVisible: boolean;
  className?: string;
}

export const PhoneVerificationMessage = ({ isVisible, className }: PhoneVerificationProps) => {
  const { __ } = useTranslations();

  if (!isVisible) {
    return null;
  }
  return (
    <div className={className}>
      <AlertBanner
        tone="success"
        data-testid="phoneValidatedViaSmsAlert"
        description={__("auth.registration.phone_verified_via_sms")}
      />
    </div>
  );
};
